import { render, staticRenderFns } from "./CheckplusFail.vue?vue&type=template&id=51b49c24&"
import script from "./CheckplusFail.vue?vue&type=script&lang=js&"
export * from "./CheckplusFail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports